var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParentPortal',{attrs:{"tabs":_vm.sidePanelComponents}},[(_vm.review)?_c('router-view',{staticClass:"main-content",attrs:{"is-loading":_vm.isLoading,"review":_vm.review,"reviews":_vm.nominationReviews,"nomination-report":_vm.nominationReport,"award-report":_vm.awardReport}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }